





























































































import DatasourceServices from '@/services/datasource';
import { DataprocessDto, DpColumnCfg } from '@/services/dataprocess';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/zh-cn';
@Component
export default class DataprocessFlinksql3 extends Vue {
  @PropSync('formData') syncFormData!: DataprocessDto;
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;

  dsSrv = new DatasourceServices();
  activeKey: string = '0';
  expandIconPosition: string = 'left';
  visibleRefData = false;
  visibleMore = false;

  dsTypeList = [
      {key: 'MySQL', value: 'MySQL'},
      {key: 'PostgreSQL', value: 'PostgreSQL'},
      {key: 'SQLServer', value: 'SQLServer'},
      {key: 'Oracle', value: 'Oracle'},
      {key: 'elasticsearch', value: 'elasticsearch'},
      {key: 'mongoDB', value: 'mongoDB'},
      {key: 'kafka', value: 'kafka'},
      {key: 'hive', value: 'hive'},
      {key: 'hbase', value: 'hbase'},
      {key: 'redis', value: 'redis'},
      {key: 'doris', value: 'doris'}
  ];
  dsObjList: any[] = [];

  mounted() {
    this.getDsList();
  }

  async onChangeDsType(e: string, index: number) {
    if (!this.syncFormData.sinksDsConfig || this.syncFormData.sinksDsConfig.length <= 0) return ;
    let v = this.syncFormData.sinksDsConfig[index];
    v.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: e });
    this.$forceUpdate();
  }

  async onChangeDs(e: number, index: number) {
    if (!this.syncFormData.sinksDsConfig || this.syncFormData.sinksDsConfig.length <= 0) return ;
    let v = this.syncFormData.sinksDsConfig[index];
    v.sinkDsId = e;
    let datatsource = v.dsList.filter((v: any) => v.id == e);
    v.sinkDsName = datatsource && datatsource.length > 0 ? datatsource[0].dsName : '';
    if(!v.sinkDsType) { v.sinkDsType = datatsource[0].dsType; } 
    v.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: e });
    this.$forceUpdate();
  }

  async onChangeTable(e: number, index: number) {
    if (!this.syncFormData.sinksDsConfig || this.syncFormData.sinksDsConfig.length <= 0) return ;
    let v = this.syncFormData.sinksDsConfig[index];
    v.sinkDsTableId = e;
    let table = v.tableList.filter((v: any) => v.id == e);
    v.sinkDsTableName = table && table.length > 0 ? table[0].tableNameEn : '';
    v.sinkDsColumns = await this.dsSrv.columns({ status_eq: 0, tableId_eq: e });

    this.$forceUpdate();
  }

  @Watch('syncFormData.id')
  async getDsList() {
    if (!this.syncFormData.sinksDsConfig || this.syncFormData.sinksDsConfig.length <= 0) return ;
    if (this.syncFormData.id) {
      for (let i = 0; i < this.syncFormData.sinksDsConfig.length; i++) {
          let v = this.syncFormData.sinksDsConfig[i];
          v.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: v.sinkDsType });
          v.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: v.sinkDsId });
      }
    } else {
      let ret = await this.dsSrv.getList({ status_eq: 0 });
      this.dsObjList = ret;
      for (let i = 0; i < this.syncFormData.sinksDsConfig.length; i++) {
          this.syncFormData.sinksDsConfig[i].dsList = ret;
      }
    }
  }

  filterOption(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  handleClick(index: number) {
    this.syncFormData.sinksDsConfig && this.syncFormData.sinksDsConfig.splice(index, 1);
  }

  @Watch('syncFormData.sinksDsConfig.length')
  onFormDataChange(newVal: number, oldVal: number) {
    debugger
    if(newVal !== oldVal) {
      let index = newVal - 1;
      this.activeKey = '' + index ;
      // this.$nextTick(() => {
      //   this.activeKey = '' + index ;
      // });
    }
  }

  addSink() {
    if (this.syncFormData.sinksDsConfig) {
      this.syncFormData.sinksDsConfig.push({
        sinkDsType: '',
        sinkDsName: '',
        sinkDsTableName: '',
        sinkDsTableLogicName: '',
        sinkDsColumns: [],
        partitionColumn: '',
        partitionColumnType: '',
        parallelism: 1,
        dsList: this.dsObjList,
        tableList: [],
      });
    }
  }

  removeList(index: number, index1: number) {
    this.syncFormData.sinksDsConfig && this.syncFormData.sinksDsConfig[index].sinkDsColumns?.splice(index1, 1);
  }

  addList(index: number) {
    let record: DpColumnCfg = {
        pkFlag: 0,
        partitionFlag: 0,
        columnNameEn: '',
        dataTypeEn: '',
        status: 0,
    };
    if (this.syncFormData.sinksDsConfig && this.syncFormData.sinksDsConfig[index]) {
      record.tableId = this.syncFormData.sinksDsConfig[index].sinkDsTableId;
      this.syncFormData.sinksDsConfig[index].sinkDsColumns?.push(record);
    }
  }

  async confirm() {
    const must: { field: 'sinkDsId' | 'sinkDsType' | 'sinkDsName' | 'sinkDsTableId' | 'sinkDsTableName' ; msessage: string }[] = [
        { field: 'sinkDsId', msessage: '目标数据源不能为空' },
        { field: 'sinkDsType', msessage: '目标数据源类型不能为空' },
        { field: 'sinkDsName', msessage: '目标数据源不能为空' },
        { field: 'sinkDsTableId', msessage: '目标数据对象不能为空' },
        { field: 'sinkDsTableName', msessage: '目标数据对象不能为空' },
    ];
    if (this.syncFormData.sinksDsConfig && this.syncFormData.sinksDsConfig.length > 0) {
      for (let i = 0; i < this.syncFormData.sinksDsConfig.length; i++) {
        let v = this.syncFormData.sinksDsConfig[i];
        for (let val of must) {
          if (!v[val.field]) {
            this.$message.error(val.msessage);
            return false;
          }
        }
      }
    }

    this.syncVisible = false;
    return true;
  }
  
  columns = [{
      title: '字段名',
      dataIndex: 'columnNameEn',
      key: 'columnNameEn',
      width: 70,
      ellipsis: true,
      scopedSlots: { customRender: 'columnNameEn' },
    },
    {
      title: '字段类型',
      dataIndex: 'dataTypeEn',
      key: 'dataTypeEn',
      width: 40,
      ellipsis: true,
      scopedSlots: { customRender: 'dataTypeEn' },
    },
    {
      title: '是否主键',
      dataIndex: 'pkFlag',
      key: 'pkFlag',
      width: 30,
      scopedSlots: { customRender: 'pkFlag' },
    },
    {
      title: '是否分区',
      dataIndex: 'partitionFlag',
      key: 'partitionFlag',
      width: 30,
      scopedSlots: { customRender: 'partitionFlag' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 40,
      scopedSlots: { customRender: 'operation' },
    },
  ];

}
